module.exports = __webpack_public_path__ + "img/Wp_2069.43889fba.png";